import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from 'api/constants';
import { resolve } from 'api/resolve';
import type { UserSettings } from 'api/user-settings/types';

import { useUserSettingsApi } from '../user-settings-api';

/** Pass a stable `select` (e.g. from `useCallback`) to read a slice of the settings without refetching. */
export const useFetchUserSettings = <TData = UserSettings>(select?: (settings: UserSettings) => TData) => {
  const { getUserSettings } = useUserSettingsApi();

  return useQuery({
    queryKey: [QUERY_KEYS.USER_SETTINGS],
    queryFn: () => resolve(getUserSettings()),
    select
  });
};
